import {
  inject,
  Injectable,
  makeEnvironmentProviders,
  PLATFORM_ID
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { HeaderItem } from '@entities/domains/header.entity';
import { environment } from '@environment/environment';
import { HeaderRepository } from '@repositories/header.repository';
import { RestApiService } from '@services/rest-api/rest-api.service';
import { filter, map, Observable, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderAdapter extends HeaderRepository {
  http = inject(RestApiService);
  platformId = inject(PLATFORM_ID);
  url = environment.drupalApi;

  getMenuheader(isEnglish: boolean): Observable<HeaderItem> {
    let targetUrl = `${this.url}views/header_rest`;

    if (isEnglish) {
      targetUrl = `${this.url}en/views/header_rest`;
    }
    return this.http.getRequest(targetUrl, {}).pipe(
      map((res: any) => res.data[0].item),
      map((res: any) => {
        return {
          topLeftnavigation: res.top_left_navigation.map((item: any) => ({
            title: item.title,
            link: item.link,
            is_active: item.is_active
          })),
          loginUrl: '/login',
          shop_menu: res.shop_menu ?? [],
          personal_menu: res.personal_menu ?? [],
          personal_menu_mobile: res.personal_menu_mobile ?? [],
          site_branding: res.site_branding ?? null,
          telkomsel_site_branding: res.telkomsel_site_branding ?? null,
          popular_keywords: res.popular_keywords ?? [],
          product_recommendation: res.product_recommendation ?? [],
          category_recommendation: res.category_recommendation ?? [],
          thematic_icon: res.thematic_icon ?? null,
          language: res.language ?? [],
          static_text: res.static_text ?? null
              };
      })
    );
  }
  override getLogoPaths(router: Router): Observable<{ logoUrl: string }> {
    return router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      switchMap((event) =>
        this.http.getRequest(`${this.url}api/paths-header-logo`, {}).pipe(
          map(({ data }: Record<string, any>) => {
            let pathLength = 0;
            let logoUrl = '';

            data.forEach((item: any) => {
              if (item.path.endsWith('/*')) {
                item.path = item.path.replace('/*', '');
              }

              if (item.path.includes('/shops')) {
                item.path = item.path.replace('/shops', '');
              }

              if (item.path.endsWith('/')) {
                item.path = item.path.replace('/', '');
              }

              if (
                event.url.includes(item.path) &&
                item.path.length > pathLength
              ) {
                pathLength = item.path.length;
              }
            });

            data.forEach((item: any) => {
              item['match'] = false;

              if (
                event.url.includes(item.path) &&
                item.path.length === pathLength
              ) {
                item['match'] = true;
              }
            });

            const isThereMatchLogo = data.find((item: any) => item['match']);

            if (isThereMatchLogo) {
              logoUrl = isThereMatchLogo.path;
            }

            return { logoUrl };
          })
        )
      )
    );
  }
}

export const provideHeaderService = () =>
  makeEnvironmentProviders([
    {
      provide: HeaderRepository,
      useClass: HeaderAdapter
    }
  ]);
